import html from "./SurveyStep.html"
import "./SurveyStep.css"
import moment from 'moment-timezone'
import "./Steps/CaptureStep.js"
import "./Steps/ConsentReviewStep.js"
import "./Steps/UnsupportedStep.js"
import "./Steps/VideoInstructionStep.js"
import "./Steps/VisualConsentStep.js"
import "./Steps/WebViewStep.js"
import "./Controls/NextButton.js"
import "./TemplateValidator.js"

var module = angular.module("ResearchKitApplicationModule");

module.directive("surveyStep",
	["$timeout", function ($timeout) {
		return {
			template: html,
			replace: false,
			restrict: "E",
			scope: {
				"stepManager": "=",
				"render": "=?"
			},
			link: function (scope, element, attrs) {
				const surveyStepElement = element.children(":first");
				scope.$watch("stepManager.step.identifier", (stepIdentifier) => {
					if (stepIdentifier) {
						surveyStepElement.removeClass("visible");
						$timeout(() => {
							surveyStepElement.addClass("visible");
						});
					}
				});
			}
		};
	}]
);

// Finalises a step from a React-component-provided StepResultModel and advances the survey.
// Mirrors StepManager.prototype.continue but skips the internal canContinue() check
// since the React component already ensures the user can proceed.
function reactStepContinue(sm, stepResult) {
	sm.surveyManager.setManagedResult(stepResult, sm.step.identifier);
	// Still honour Angular-side validation rules (e.g. cross-field rules defined on the step)
	if (!sm.surveyManager.stepCanContinue({ step: sm.step, canContinue: function () { return true; } })) {
		return;
	}
	sm.dismissedDate = moment().format('YYYY-MM-DDTHH:mm:ss.SSSZ');
	// Stamp the dismissed date onto the step and every child question result. 
	var finalizedResult = Object.assign({}, stepResult, {
		EndDate: sm.dismissedDate,
		QuestionResults: (stepResult.QuestionResults || []).map(function (questionResult) {
			return Object.assign({}, questionResult, { EndDate: sm.dismissedDate });
		})
	});
	sm.surveyManager.setManagedResult(finalizedResult, sm.step.identifier);
	sm.surveyManager.stepDidFinish(sm, true);
}

module.controller("surveyStepController", ["$scope", "templateValidator",
	function ($scope, templateValidator) {

		if (_.isUndefined($scope.render)) {
			$scope.render = true;
		}

		$scope.isLastInstructionStep = function () {
			var lastInstructionStepIndex = -1;
			for (var i = 0; i < $scope.template.steps.length; i++) {
				if ($scope.template.steps[i].type === 'InstructionStep') {
					lastInstructionStepIndex = i;
				} else {
					break;
				}
			}

			if ($scope.stepIndex === lastInstructionStepIndex) {
				return true;
			}
			return false;
		};

		$scope.getStyles = function () {
			if (!$scope.stepManager) { return {}; }
			var styles = $scope.stepManager.getBackgroundStyles();
			if ($scope.stepManager && $scope.stepManager.surveyManager && $scope.stepManager.surveyManager.getMode() !== "Design") {
				styles["width"] = "auto";
			}
			return styles;
		};

		$scope.getClasses = function () {
			var classes = {};
			if (!$scope.stepManager) { return; }
			if ($scope.stepManager.getFormStyle() == 'cardBased') {
				classes["card-based"] = true;
			}
			if ($scope.stepManager.getFormStyle() == 'v2') {
				classes["survey-step-v2"] = true;
			}
			return classes;
		}

		$scope.$on("SurveyTemplateModified", function (evt, data) {
			// template is available on the stepManager.surveyManager but we want to avoid adding another deep watch
			$scope.templateValidationErrors = templateValidator.validate($scope.stepManager.step, $scope.stepManager.surveyManager.template);
		});

		function buildBaseStepProps(sm, extraProps) {
			return Object.assign({
				key: sm.surveyManager.managedStepIdentifiers.length - 1, // ensure we remount if we navigate back and forth between steps of the same type
				step: sm.step,
				surveyDefinition: sm.surveyManager.template,
				nextStep: sm.surveyManager.nextStep(),
				managedResults: sm.surveyManager.getActiveManagedResults(),
				predicateExpressionEvaluator: sm.surveyManager.getPredicateExpressionEvaluator(),
				presentedDate: sm.presentedDate,
				onContinue: function (stepResult) {
					$scope.$apply(function () {
						reactStepContinue($scope.stepManager, stepResult);
					});
				},
				onBack: function () {
					$scope.$apply(function () {
						$scope.stepManager.back();
					});
				},
				onResultChange: function (stepResult) {
					$scope.stepManager.surveyManager.setManagedResult(stepResult, $scope.stepManager.step.identifier);
					if (!$scope.$$phase && !$scope.$root.$$phase) {
						$scope.$apply();
					}
				}
			}, extraProps || {});
		}

		function makePropsFactory(buildFn) {
			var cached = null;
			return function () {
				if (!$scope.stepManager) return null;
				var newProps = buildFn($scope.stepManager);
				if (!angular.equals(cached, newProps)) {
					cached = newProps;
				}
				return cached;
			};
		}

		$scope.instructionStepProps = makePropsFactory(function (sm) {
			return buildBaseStepProps(sm, {
				visitedStepIdentifiers: sm.surveyManager.managedStepIdentifiers,
				linkSurvey: !!sm.surveyManager.linkSurvey
			});
		});

		$scope.formStepProps = makePropsFactory(function (sm) {
			return buildBaseStepProps(sm);
		});

		$scope.questionStepProps = makePropsFactory(function (sm) {
			return buildBaseStepProps(sm);
		});

		$scope.completionStepProps = makePropsFactory(function (sm) {
			return buildBaseStepProps(sm);
		});

		$scope.countdownStepProps = makePropsFactory(function (sm) {
			return buildBaseStepProps(sm);
		});

		$scope.waitStepProps = makePropsFactory(function (sm) {
			return buildBaseStepProps(sm);
		});

		let surveyHeaderProps = null;
		$scope.surveyHeaderProps = function () {
			const isWaitStep = $scope.stepManager.step.type === 'WaitStep';
			let newProps = {
				onBack: function () {
					$scope.stepManager.back();
					$scope.$apply();
				},
				onContinue: function () {
					$scope.stepManager.continue();
					$scope.$apply();
				},
				onClose: function () {
					$scope.stepManager.closeSurvey();
					$scope.$apply();
				},
				onSaveAndClose: function () {
					$scope.stepManager.saveAndCloseSurvey();
					$scope.$apply();
				},
				canGoBack: !isWaitStep && $scope.stepManager.canGoBack(),
				showSaveAndClose: !isWaitStep && $scope.stepManager.showSaveAndClose(),
				showCancelButton: $scope.stepManager.showCancelButton(),
				stepDefinition: $scope.stepManager.step,
				surveyDefinition: $scope.stepManager.surveyManager.template
			};

			if (!angular.equals(surveyHeaderProps, newProps)) {
				surveyHeaderProps = newProps;
			}
			return surveyHeaderProps;
		}
	}
]);